import React from "react";
import { requestPasswordReset, resetPassword } from "../scripts/auth-helper";
import { captureException } from "@sentry/core";

export function useRequestPasswordReset() {
  const [loading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  async function requestReset(emailAddress: string) {
    try {
      setIsLoading(true);
      const res = await requestPasswordReset(emailAddress, location.search);
      if (res == "missingEmail") {
        setError("passwordResetInvalidEmail");
        return false;
      }
      return true;
    } catch (err) {
      console.error(err);
      captureException(err);
      setError("didNotWork");
      return false;
    } finally {
      setIsLoading(false);
    }
  }

  return {
    loading,
    error,
    requestReset,
  };
}

export function useResetPassword(resetToken?: string | null) {
  const [loading, setIsLoading] = React.useState(false);
  const [success, setIsSuccess] = React.useState(false);
  const [error, setError] = React.useState("");

  async function reset(password: string, confirm: string) {
    if (!resetToken) {
      setError("invalidResetLink");
      return false;
    }
    if (password !== confirm) {
      setError("passwordsMustMatch");
      return false;
    }
    try {
      setIsLoading(true);
      const error = await resetPassword(resetToken, password);
      switch (error) {
        case "ok":
          setIsSuccess(true);
          return true;
        case "error":
          setIsSuccess(false);
          setError("didNotWork");
          return false;
        case "Invalid resetToken":
          console.error("Invalid resetToken");
          setIsSuccess(false);
          setError("invalidResetLink");
          return false;
      }
    } catch (err) {
      console.error(err);
      setError("didNotWork");
      return false;
    } finally {
      setIsLoading(false);
    }
  }

  return {
    loading,
    success,
    error: error || (resetToken ? "" : "invalidResetLink"),
    reset,
  };
}
